export const ProjectDataStatusList: any = [
    { value: -1, label: 'project_list_state_all'},
    { value: 0, label: 'project_list_state_draft'},
    { value: 1, label: 'project_list_state_review'},
    { value: 2, label: 'project_list_state_offer'},
    { value: 3, label: 'project_list_state_accepted'},
    { value: 4, label: 'project_list_state_delivered'},
    { value: 5, label: 'project_list_state_cancelled'}
  ];
